import { useSelector } from "react-redux";
import useClipboardGuard from "../hooks/useClipboardGuard";

export default function AuthenticatedClipboardGuard({ children }) {
  const auth = useSelector((state) => state.auth.auth);
  useClipboardGuard(auth);
  return children;
}
